/** @jsx jsx */
import { useThemeUI } from "theme-ui"
// info le comment jsx nous permet d'omettre l'import de React
// qui est requis mais qui provoque des warning parceque, à juste titre
// il n'est pas utilisé puisque nous ne retournons pas un composant mais
// un objet js représentant notre "skin" (pas un theme au sens de Theme-UI, 
// on est sur du hack là ...)

export default props => {
  const ctxThemeUI = useThemeUI()
  const { colorMode } = ctxThemeUI
  return (
    {
      ".header-quizz h1": {
        // mt: -3,
        mt: 0,
        fontFamily: "heading",
        fontWeight: 900,
        lineHeight: 1.1,
        fontSize: "40px",
      },
      ".body-quizz": {
        fontFamily: "body",
        minHeight: 285,
        "h2, h4": {
          fontFamily: "heading",
          color: "primary",
          textAlign: "justify",
          textJustify: "inter-word",
        },
        ".description": {
          mt: "3rem",
          mb: "3rem",
          textAlign: "justify",
          textJustify: "inter-word",
        },
        ".choices": {
          mt: "3rem",
          mb: "3rem",
          p: "1.5rem",
          border: "1px solid",
          // borderColor: "highlight",
          borderColor: "primary",
          borderRadius: "1rem",
          "& .radio, & .checkbox": {
            pt: ".5rem",
            pb: ".5rem",
            input: {
              mr: "1rem"
            }
          },
        },
        ".buttons": {
          textAlign: "center",
          button: {
            fontSize: "18px",
            padding: "16px",
            borderRadius: "32px",
          }
        }
      },
      ".quizz-viewer": {
        a: {
          color: `primary`,
          "&:hover": {
            textDecoration: "underline",
          },
        },
        ".container-evaluation-quizz, .container-evaluation-partie": {
          paddingBottom: "2rem",
          borderBottom: "1px solid",
          borderColor: "primary",
          marginBottom: "2rem",
          textAlign: "justify",
          textJustify: "inter-word",
        },
        ".container-evaluation-quizz h3": {
          color: "primary",
          fontFamily: "heading",
          textAlign: "center",
          fontSize: 3
        },
        ".container-evaluation-partie h4": {
          color: "primary",
          fontFamily: "heading",
          // textAlign: "center",
          fontSize: 3
        },
        "svg.speedometer .current-value": {
          fill: colorMode === "light" ? "#555 !important" : "rgb(255,255,255) !important",
        },
        "svg.speedometer .pointer": {
          fill: "primary !important"
        },
        // ".container-evaluation-partie .score": {
        ".score": {
          display: "none"
        }
      },
      ".debugger": {
        position: "fixed",
        color: "#000",
      },
      button: {
        mr: 1,
        color: "#fff",
        backgroundColor: "primary",
        border: "2px solid",
        borderColor: "primary",
        padding: 1,
        borderRadius: 4,
        cursor: "pointer",
        transitionProperty: "color, background-color",
        transitionDuration: "0.2s",
        "&:hover": {
          color: "primary",
          backgroundColor: "#fff",
        },
        "&:disabled": {
          color: colorMode === "light" ? "muted" : "muted",
          backgroundColor:
            colorMode === "light" ? "#fff" : "transparent",
          borderColor: colorMode === "light" ? "muted" : "muted",
          border: "2px solid",
          cursor: "default",
        },
      },
      ".tools-bar button": {
        color: "muted",
        backgroundColor:
          colorMode === "light" ? "#fff" : "transparent",
        border: "none",
        "&:hover": {
          color: "primary",
        },
      },

      // Stepper

      ".progressbar li.active": {
        color: "primary",
      },
      ".progressbar li.active:before": {
        borderColor: "primary",
        backgroundColor: "primary",
        color: "white",
      },
      ".progressbar li.active + li:after": {
        backgroundColor: "primary",
      },

      ".progressbar li:not(.active)": {
        color: colorMode === "light" ? "text" : "background",
      },
    }

  )
} 
